import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import CTAPanel from "@/components/base/CTAPanel";
import { Link } from "react-router-dom";

const markets = [
  {
    title: "Federal Government",
    description: "Mitaja has supported federal enterprise IT programs through higher-tier prime contractors, with documented multi-year performance across infrastructure, network engineering, and database services.",
    icon: "ri-government-line",
    href: "/experience/usa-government",
    tags: ["Subcontract", "Enterprise IT"],
  },
  {
    title: "State & Local Government",
    description: "Positioned for SLED technology programs with documented state/local application integration experience and a broad service portfolio for government agencies.",
    icon: "ri-building-2-line",
    href: "/experience/usa-government",
    tags: ["SLED", "Integration"],
  },
  {
    title: "Government Prime Contractors",
    description: "Mitaja is a reliable technology partner for prime contractors seeking specialized technical capabilities, qualified resources, and flexible subcontracting support for government programs.",
    icon: "ri-star-line",
    href: "/contact",
    tags: ["Teaming", "Subcontract"],
  },
  {
    title: "Commercial Enterprise",
    description: "Technical resource staffing and consulting support for commercial enterprise clients, including airline, healthcare, technology, and enterprise organizations.",
    icon: "ri-building-line",
    href: "/experience/commercial",
    tags: ["Staffing", "Consulting"],
  },
];

export default function Markets() {

  return (
    <Layout>
      <PageHero
        title="Markets We Serve"
        subtitle="Government & Enterprise"
        description="Mitaja Corporation delivers technology services and engineering support across federal, state, local, and commercial markets."
        size="lg"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <SectionHeader
            title="Target Markets"
            description="Mitaja partners with organizations across public-sector and commercial markets that require specialized technical capabilities and qualified resources."
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {markets.map((market) => (
              <Link
                key={market.title}
                to={market.href}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="card-base card-hover p-8 cursor-pointer group block"
              >
                <div className="w-14 h-14 rounded-xl bg-primary-50 flex items-center justify-center mb-6 group-hover:bg-primary-100 transition-colors">
                  <i className={`${market.icon} text-primary-600 text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-foreground-900 mb-3 group-hover:text-primary-700 transition-colors">
                  {market.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {market.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {market.tags.map((tag) => (
                    <span key={tag} className="text-xs px-2.5 py-1 rounded-full bg-secondary-50 text-secondary-700 font-medium">
                      {tag}
                    </span>
                  ))}
                </div>
                <span className="mt-5 flex items-center text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  Learn more
                  <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTAPanel
        title="Serve Your Market With Mitaja"
        description="Mitaja provides specialized technical capabilities and qualified resources for government and enterprise programs."
        primaryAction={{ label: "Contact Us", href: "/contact" }}
        secondaryAction={{ label: "View Capabilities", href: "/capabilities" }}
        variant="dark"
      />
    </Layout>
  );
}